module.exports = __webpack_public_path__ + "static/images/diners.1z3vLAz.svg";